export default __webpack_public_path__ + "static/media/default.14704e15cd60cdda60cd6be08ca3eb8e.png";